import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { newReply } from "../../redux/actions/postActions";
import PostForm from "./PostForm";
import { useTranslation } from "react-i18next";

function CommentForm() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onSubmit = (formData) => {
    return new Promise((resolve, reject) => {
      dispatch(newReply({ data: formData, id }))
        .then(resolve)
        .catch(reject);
    });
  };

  return (
    <PostForm
      onSubmit={onSubmit}
      isReply
      placeholder={t("replyPlaceholder")}
      buttonText={t("replyButton")}
    />
  );
}

export default CommentForm;
